import { render, staticRenderFns } from "./DeliveryMode.vue?vue&type=template&id=683284c3&scoped=true&"
import script from "./DeliveryMode.vue?vue&type=script&lang=js&"
export * from "./DeliveryMode.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryMode.vue?vue&type=style&index=0&id=683284c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683284c3",
  null
  
)

export default component.exports